import { STORAGE_KEYS } from '@/lib/api/endpoints';
import { decodeJwtPayload, getTenantIdFromToken } from '@/lib/auth/token-utils';

/**
 * Persist tenant JWT from OAuth / email-verification query params (legacy parity).
 * Must run synchronously before AuthGuard checks on first paint — see main.tsx.
 */
export function bootstrapTenantSessionFromUrl(): boolean {
  if (typeof window === 'undefined') return false;

  const params = new URLSearchParams(window.location.search);
  const urlToken = params.get('token');
  if (!urlToken) return false;

  const urlTenantId = params.get('tenant_id');
  const jwt = decodeJwtPayload(urlToken);
  const jwtTenantId = getTenantIdFromToken(urlToken);
  const tenantId = urlTenantId || jwtTenantId;
  if (!tenantId) return false;

  const tenantSlug =
    params.get('tenant_slug') || jwt?.tenant_slug || localStorage.getItem(STORAGE_KEYS.tenantSlug) || '';
  const tenantName =
    params.get('tenant_name') ||
    localStorage.getItem(STORAGE_KEYS.tenantName) ||
    tenantSlug ||
    'Tenant';

  localStorage.setItem(STORAGE_KEYS.tenantToken, urlToken);
  localStorage.setItem(STORAGE_KEYS.tenantId, tenantId);
  if (tenantSlug) {
    localStorage.setItem(STORAGE_KEYS.tenantSlug, tenantSlug);
  }
  localStorage.setItem(STORAGE_KEYS.tenantName, tenantName);

  const cleaned = new URLSearchParams(window.location.search);
  cleaned.delete('token');
  cleaned.delete('tenant_id');
  cleaned.delete('tenant_name');
  cleaned.delete('tenant_slug');
  const qs = cleaned.toString();
  const nextUrl = qs ? `${window.location.pathname}?${qs}` : window.location.pathname;
  window.history.replaceState({}, document.title, nextUrl);

  return true;
}
